import { render, staticRenderFns } from "./NewEvaluationCriterialDimensionsST.vue?vue&type=template&id=5e13dd8a&scoped=true"
import script from "./NewEvaluationCriterialDimensionsST.vue?vue&type=script&lang=js"
export * from "./NewEvaluationCriterialDimensionsST.vue?vue&type=script&lang=js"
import style0 from "./NewEvaluationCriterialDimensionsST.vue?vue&type=style&index=0&id=5e13dd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e13dd8a",
  null
  
)

export default component.exports